"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBroadbandConnectionType = exports.ProductManufacturerId = exports.ProductManufacturer = exports.ProductMnp = exports.ProductStatus = void 0;
/**
 * Enum für den Parameter product_status
 */
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["VIEW"] = "view";
    ProductStatus["LIST"] = "list";
    ProductStatus["ADD"] = "add";
    ProductStatus["CONFIRMATION"] = "conf";
})(ProductStatus || (exports.ProductStatus = ProductStatus = {}));
/**
 * Enum für den Parameter product_mnp
 */
var ProductMnp;
(function (ProductMnp) {
    ProductMnp["WITH_MNP"] = "1";
    ProductMnp["WITHOUT_MNP"] = "0";
})(ProductMnp || (exports.ProductMnp = ProductMnp = {}));
/**
 * Enum für den Parameter product_manufacturer
 */
var ProductManufacturer;
(function (ProductManufacturer) {
    ProductManufacturer["CONGSTAR"] = "congstar";
})(ProductManufacturer || (exports.ProductManufacturer = ProductManufacturer = {}));
/**
 * Enum für den Parameter product_manufacturer_id
 */
var ProductManufacturerId;
(function (ProductManufacturerId) {
    ProductManufacturerId["CONGSTAR"] = "111111";
})(ProductManufacturerId || (exports.ProductManufacturerId = ProductManufacturerId = {}));
/**
 * Enum für den Parameter product_broadband_connection_type
 */
var ProductBroadbandConnectionType;
(function (ProductBroadbandConnectionType) {
    ProductBroadbandConnectionType["NEW_CONNECTION"] = "neuanschluss";
    ProductBroadbandConnectionType["CHANGE_OF_PROVIDER"] = "anbieterwechsel";
})(ProductBroadbandConnectionType || (exports.ProductBroadbandConnectionType = ProductBroadbandConnectionType = {}));
